/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerritoryItem } from './TerritoryItem';
import {
    TerritoryItemFromJSON,
    TerritoryItemFromJSONTyped,
    TerritoryItemToJSON,
    TerritoryItemToJSONTyped,
} from './TerritoryItem';

/**
 * 
 * @export
 * @interface TerritorySuggestionsResponse
 */
export interface TerritorySuggestionsResponse {
    /**
     * List of territory suggestions
     * @type {Array<TerritoryItem>}
     * @memberof TerritorySuggestionsResponse
     */
    suggestions: Array<TerritoryItem>;
}

/**
 * Check if a given object implements the TerritorySuggestionsResponse interface.
 */
export function instanceOfTerritorySuggestionsResponse(value: object): value is TerritorySuggestionsResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function TerritorySuggestionsResponseFromJSON(json: any): TerritorySuggestionsResponse {
    return TerritorySuggestionsResponseFromJSONTyped(json, false);
}

export function TerritorySuggestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerritorySuggestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(TerritoryItemFromJSON)),
    };
}

export function TerritorySuggestionsResponseToJSON(json: any): TerritorySuggestionsResponse {
    return TerritorySuggestionsResponseToJSONTyped(json, false);
}

export function TerritorySuggestionsResponseToJSONTyped(value?: TerritorySuggestionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(TerritoryItemToJSON)),
    };
}

